import { useState, useEffect, useCallback } from 'react';

export const hasRussianLetters = (str) => {
  const regex = /[а-яА-ЯЁё]/;
  return regex.test(str);
}

export const useDebounce = (value, delay, action=()=>{}) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    // Устанавливаем таймер
    const handler = setTimeout(() => {
      setDebouncedValue(value);
      action(value);
    }, delay);

    // Очищаем таймер, если значение изменилось до истечения delay
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

/**Хук-надстройка над useState которая дополняет его сохранением в localStorage */
export const useLocalStorageState = (key, initialValue) => {
  const [state, setState_] = useState(() => {
    const storedValue = localStorage.getItem(key);
    if (storedValue === null) {
      return initialValue;
    }

    let parsedValue;
    try {
      parsedValue = JSON.parse(storedValue);
    } catch (e) {
      parsedValue = initialValue;
    }
    return parsedValue;
  });
  const setState = useCallback((value) => {
    setState_(value);
    localStorage.setItem(key, JSON.stringify(value));
  }, [key]);
  const clearState = useCallback(() => {
    setState_(initialValue);
    localStorage.removeItem(key);
  }, [key, initialValue]);
  const setOnlyStorage = useCallback((value) => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [key]);
  return [state, setState, clearState, setOnlyStorage];
}